import React from 'react';
import { WithIcon } from './WithIcon';

export const IconWatch = WithIcon(
  'Watch',
  '0 0 30 30',
  <path d="M8.11,6.68,22.4,15,8.11,23.31V6.68M6.61,4.08V25.92L25.39,15,6.61,4.08Z" />
);
